import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Api/list_medicine";

function Medicine() {
  const navigate = useNavigate();

  const [medicine, setMedicine] = useState(null);

  useEffect(() => {
    const fetchMedicine = async () => {
      try {
        const res = await axios.get(API_URL);
        let data = res.data.data || [];

        // Sort by ID (oldest first)
        data = data.sort((a, b) => Number(a.id) - Number(b.id));

        // Sirf pehla record set karna
        if (data.length > 0) {
          setMedicine(data[0]);
        }
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchMedicine();
  }, []);

  if (!medicine) return null; // Data load hone tak blank rakho

  return (
    <>
      <div className="container-fluid bg-light d-flex align-items-center justify-content-center ">
        <div className="row">

          {/* LEFT SECTION */}
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-center">
            <h5>{medicine.heading}</h5>

            <h1 className="fw-bold">
              {medicine.sub_heading}
            </h1>

            <p>{medicine.description}</p>

            {/* <button className="custom-btn text-white mt-2" onClick={()=> navigate("/products")}>
              Place an Order now 
              <span><i className="bi bi-chevron-right ms-1"></i></span>
            </button> */}
             <button className="custom-btn text-white mt-2" onClick={()=> navigate("/products")}>
              Shop now 
              <span><i className="bi bi-chevron-right ms-1"></i></span>
            </button>
          </div>

          {/* RIGHT SECTION (IMAGE) */}
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
            <img
              src={`${BASE_URL}/${medicine.image}`}
              className="img-fluid w-100"
              alt="Medicine"
            />
          </div>

        </div>
      </div>
    </>
  );
}

export default Medicine;